export enum Roles {
    ORDER_LIST = 'order-list',
    ORDER_DETAILS = 'order-details',
    ORDER_CREATE = 'order-create',
    ORDER_DELETE = 'order-delete',
    ORDER_CHANGE_STATUS = 'order-change-status',
    ORDER_SHOT_CHANGE_STATUS = 'order-shot-change-status',
    ORDER_UPLOAD_IMAGES = 'order-upload-images',
    ORDER_DELETE_IMAGES = 'order-delete-images',
    ORDER_DOWNLOAD_IMAGES = 'order-download-images',
    ORDER_DOWNLOAD_SHOOTINGLIST = 'order-download-shootinglist',
    STYLE_LIST = 'style-list',
    STYLE_DETAILS = 'style-details',
    STYLE_SET_DEFAULT_COLOR = 'style-set-default-color',
    STYLE_UPLOAD_IMAGES = 'style-upload-images',
    STYLE_DOWNLOAD_IMAGES = 'style-download-images',
    STYLE_DELETE_IMAGES = 'style-delete-images',
    STYLE_DOWNLOAD_SHOOTINGLIST = 'style-download-shootinglist',
    TEMPLATE_LIST = 'template-list',
    TEMPLATE_CREATE = 'template-create',
    TEMPLATE_DELETE = 'template-delete',
    PHOTOGRAPHER_LIST = 'photographer-list',
}
